module.exports = __webpack_public_path__ + "static/img/e5.e0d0c54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/e5.png
// module id = 3xV4
// module chunks = 0